// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hr-chart-root {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
}

.hr-summary-section {
  --hr-accent: #0a7ebd;
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--hr-accent) 12%, white) 0%,
    #fff 48%,
    #f6f8fb 100%
  );
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 20px 18px 22px;
  margin-bottom: 20px;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);
}

.hr-summary-heading {
  margin: 0 0 16px;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.2px;
  color: #0f172a;
}

@media (max-width: 600px) {
  .hr-summary-section {
    padding: 14px 10px 18px;
    border-radius: 14px;
  }
  .hr-summary-heading {
    font-size: 1.15rem;
    margin-bottom: 12px;
  }
  .hr-chart-canvas {
    min-height: 330px;
  }
  .hr-chart-canvas svg {
    min-height: 330px;
  }
}

.hr-summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 12px;
}

.hr-summary-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px 12px;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
}

.hr-summary-card__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--hr-accent);
  margin-bottom: 6px;
}

.hr-summary-card__icon svg {
  font-size: 26px;
}

.hr-summary-card__icon--tag {
  position: relative;
  flex-direction: column;
  gap: 2px;
}

.hr-summary-card__icon--tag span {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #64748b;
}

.hr-summary-card__value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
}

.hr-summary-card__unit {
  font-size: 0.85rem;
  font-weight: 500;
  color: #64748b;
}

.hr-summary-card__label {
  margin-top: 6px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
}

.hr-chart-panel-wrap {
  position: relative;
  width: 100%;
  padding: 0 8px;
}

.hr-chart-canvas {
  width: 100%;
  margin-top: 8px;
  border-radius: 14px;
  background: color-mix(in srgb, #0f172a 3%, transparent);
  border: 1px solid rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.hr-chart-y-label {
  position: absolute;
  left: 4px;
  top: 28px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  z-index: 1;
}

.hr-chart-canvas svg {
  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
}

.hr-chart-tick {
  font-size: 11px;
  font-weight: 600;
  fill: #0f172a;
}

.hr-chart-tick--y {
  font-size: 11px;
  font-weight: 600;
}

.hr-chart-axis-title {
  font-size: 11px;
  font-weight: 600;
  fill: #0f172a;
}

.hr-chart-line {
  filter: drop-shadow(0 0 3px rgba(255, 51, 75, 0.9)) drop-shadow(0 0 8px rgba(255, 51, 75, 0.5)) drop-shadow(0 0 14px rgba(255, 51, 75, 0.25));
}

.hr-chart-slider {
  position: relative;
  margin: 16px auto 8px;
  padding: 0 8px 28px;
}

.hr-chart-slider__input {
  appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background: linear-gradient(90deg, #e2e8f0, #cbd5e1);
  outline: none;
}

.hr-chart-slider__input::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ff4b4b;
  cursor: pointer;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.2);
}

.hr-chart-slider__input::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ff4b4b;
  cursor: pointer;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.2);
}

.hr-chart-slider__readout {
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
  color: #334155;
}

.hr-chart-slider__readout strong {
  color: #0f172a;
  font-weight: 700;
}

/* Permanent Max HR Pulse Circle Animation */
@keyframes hr-pulse-scale {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2.4);
    opacity: 0;
  }
}

.hr-pulse-circle {
  animation: hr-pulse-scale 2s cubic-bezier(0.16, 1, 0.3, 1) infinite;
}

/* ---- Dark mode (matches iOS HrChartTheme) ---- */
.hr-chart-root--dark .hr-summary-section,
html[data-theme="dark"] .hr-chart-root .hr-summary-section {
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--hr-accent) 22%, #0d1117) 0%,
    #0d1117 52%,
    #111827 100%
  );
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
}

.hr-chart-root--dark .hr-summary-heading,
html[data-theme="dark"] .hr-chart-root .hr-summary-heading,
body[data-theme="dark"] .hr-chart-root .hr-summary-heading {
  color: #f8fafc !important;
}

.hr-chart-root--dark .hr-summary-card,
html[data-theme="dark"] .hr-chart-root .hr-summary-card {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: none;
}

.hr-chart-root--dark .hr-summary-card__icon--tag span,
html[data-theme="dark"] .hr-chart-root .hr-summary-card__icon--tag span {
  color: rgba(248, 250, 252, 0.55);
}

.hr-chart-root--dark .hr-summary-card__value,
html[data-theme="dark"] .hr-chart-root .hr-summary-card__value {
  color: #f8fafc;
}

.hr-chart-root--dark .hr-summary-card__unit,
.hr-chart-root--dark .hr-summary-card__label,
html[data-theme="dark"] .hr-chart-root .hr-summary-card__unit,
html[data-theme="dark"] .hr-chart-root .hr-summary-card__label {
  color: rgba(248, 250, 252, 0.45);
}

.hr-chart-root--dark .hr-chart-canvas,
html[data-theme="dark"] .hr-chart-root .hr-chart-canvas {
  background: #0d1117;
  border-color: rgba(255, 255, 255, 0.08);
}

.hr-chart-root--dark .hr-chart-y-label,
html[data-theme="dark"] .hr-chart-root .hr-chart-y-label {
  color: rgba(255, 255, 255, 0.45);
}

.hr-chart-root--dark .hr-chart-tick,
.hr-chart-root--dark .hr-chart-axis-title,
html[data-theme="dark"] .hr-chart-root .hr-chart-tick,
html[data-theme="dark"] .hr-chart-root .hr-chart-axis-title {
  fill: rgba(255, 255, 255, 0.85);
}

html[data-theme="light"] .hr-chart-root .hr-chart-tick,
html[data-theme="light"] .hr-chart-root .hr-chart-axis-title,
body[data-theme="light"] .hr-chart-root .hr-chart-tick,
body[data-theme="light"] .hr-chart-root .hr-chart-axis-title,
body.light-mode .hr-chart-root .hr-chart-tick,
body.light-mode .hr-chart-root .hr-chart-axis-title {
  fill: #0f172a !important;
}

.hr-chart-root--dark .hr-chart-slider__input,
html[data-theme="dark"] .hr-chart-root .hr-chart-slider__input {
  background: linear-gradient(90deg, #1f2937, #374151);
}

.hr-chart-root--dark .hr-chart-slider__input::-webkit-slider-thumb,
html[data-theme="dark"] .hr-chart-root .hr-chart-slider__input::-webkit-slider-thumb {
  border-color: #0d1117;
}

.hr-chart-root--dark .hr-chart-slider__input::-moz-range-thumb,
html[data-theme="dark"] .hr-chart-root .hr-chart-slider__input::-moz-range-thumb {
  border-color: #0d1117;
}

.hr-chart-root--dark .hr-chart-slider__readout,
html[data-theme="dark"] .hr-chart-root .hr-chart-slider__readout {
  color: rgba(248, 250, 252, 0.7);
}

.hr-chart-root--dark .hr-chart-slider__readout strong,
html[data-theme="dark"] .hr-chart-root .hr-chart-slider__readout strong {
  color: #f8fafc;
}

.hr-chart-root--compact {
  max-width: none;
}

.hr-chart-root--compact .hr-summary-section {
  padding: 10px 10px 12px;
  margin-bottom: 8px;
  border-radius: 14px;
}

.hr-chart-root--compact .hr-summary-heading {
  font-size: 0.92rem;
  margin-bottom: 10px;
}

.hr-chart-root--compact .hr-summary-cards {
  gap: 8px;
}

.hr-chart-root--compact .hr-chart-canvas {
  min-height: 0;
  margin-top: 4px;
}

`, "",{"version":3,"sources":["webpack://./src/components/ExerciseHRChart.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB;;;;;GAKC;EACD,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,uDAAuD;EACvD,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6IAA6I;AAC/I;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;AACf;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,mEAAmE;AACrE;;AAEA,mDAAmD;AACnD;;EAEE;;;;;GAKC;EACD,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;AACjB","sourcesContent":[".hr-chart-root {\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.hr-summary-section {\n  --hr-accent: #0a7ebd;\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--hr-accent) 12%, white) 0%,\n    #fff 48%,\n    #f6f8fb 100%\n  );\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 16px;\n  padding: 20px 18px 22px;\n  margin-bottom: 20px;\n  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);\n}\n\n.hr-summary-heading {\n  margin: 0 0 16px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n  color: #0f172a;\n}\n\n@media (max-width: 600px) {\n  .hr-summary-section {\n    padding: 14px 10px 18px;\n    border-radius: 14px;\n  }\n  .hr-summary-heading {\n    font-size: 1.15rem;\n    margin-bottom: 12px;\n  }\n  .hr-chart-canvas {\n    min-height: 330px;\n  }\n  .hr-chart-canvas svg {\n    min-height: 330px;\n  }\n}\n\n.hr-summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 12px;\n}\n\n.hr-summary-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 14px 12px;\n  text-align: center;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);\n}\n\n.hr-summary-card__icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--hr-accent);\n  margin-bottom: 6px;\n}\n\n.hr-summary-card__icon svg {\n  font-size: 26px;\n}\n\n.hr-summary-card__icon--tag {\n  position: relative;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.hr-summary-card__icon--tag span {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: #64748b;\n}\n\n.hr-summary-card__value {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.2;\n}\n\n.hr-summary-card__unit {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.hr-summary-card__label {\n  margin-top: 6px;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #94a3b8;\n}\n\n.hr-chart-panel-wrap {\n  position: relative;\n  width: 100%;\n  padding: 0 8px;\n}\n\n.hr-chart-canvas {\n  width: 100%;\n  margin-top: 8px;\n  border-radius: 14px;\n  background: color-mix(in srgb, #0f172a 3%, transparent);\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.hr-chart-y-label {\n  position: absolute;\n  left: 4px;\n  top: 28px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  z-index: 1;\n}\n\n.hr-chart-canvas svg {\n  display: block;\n  width: 100%;\n  height: auto;\n  overflow: visible;\n}\n\n.hr-chart-tick {\n  font-size: 11px;\n  font-weight: 600;\n  fill: #0f172a;\n}\n\n.hr-chart-tick--y {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.hr-chart-axis-title {\n  font-size: 11px;\n  font-weight: 600;\n  fill: #0f172a;\n}\n\n.hr-chart-line {\n  filter: drop-shadow(0 0 3px rgba(255, 51, 75, 0.9)) drop-shadow(0 0 8px rgba(255, 51, 75, 0.5)) drop-shadow(0 0 14px rgba(255, 51, 75, 0.25));\n}\n\n.hr-chart-slider {\n  position: relative;\n  margin: 16px auto 8px;\n  padding: 0 8px 28px;\n}\n\n.hr-chart-slider__input {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 4px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #e2e8f0, #cbd5e1);\n  outline: none;\n}\n\n.hr-chart-slider__input::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #ff4b4b;\n  cursor: pointer;\n  border: 2px solid #fff;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.2);\n}\n\n.hr-chart-slider__input::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #ff4b4b;\n  cursor: pointer;\n  border: 2px solid #fff;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.2);\n}\n\n.hr-chart-slider__readout {\n  margin-top: 10px;\n  text-align: center;\n  font-size: 14px;\n  color: #334155;\n}\n\n.hr-chart-slider__readout strong {\n  color: #0f172a;\n  font-weight: 700;\n}\n\n/* Permanent Max HR Pulse Circle Animation */\n@keyframes hr-pulse-scale {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(2.4);\n    opacity: 0;\n  }\n}\n\n.hr-pulse-circle {\n  animation: hr-pulse-scale 2s cubic-bezier(0.16, 1, 0.3, 1) infinite;\n}\n\n/* ---- Dark mode (matches iOS HrChartTheme) ---- */\n.hr-chart-root--dark .hr-summary-section,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-summary-section {\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--hr-accent) 22%, #0d1117) 0%,\n    #0d1117 52%,\n    #111827 100%\n  );\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);\n}\n\n.hr-chart-root--dark .hr-summary-heading,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-summary-heading,\nbody[data-theme=\"dark\"] .hr-chart-root .hr-summary-heading {\n  color: #f8fafc !important;\n}\n\n.hr-chart-root--dark .hr-summary-card,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-summary-card {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: none;\n}\n\n.hr-chart-root--dark .hr-summary-card__icon--tag span,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-summary-card__icon--tag span {\n  color: rgba(248, 250, 252, 0.55);\n}\n\n.hr-chart-root--dark .hr-summary-card__value,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-summary-card__value {\n  color: #f8fafc;\n}\n\n.hr-chart-root--dark .hr-summary-card__unit,\n.hr-chart-root--dark .hr-summary-card__label,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-summary-card__unit,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-summary-card__label {\n  color: rgba(248, 250, 252, 0.45);\n}\n\n.hr-chart-root--dark .hr-chart-canvas,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-chart-canvas {\n  background: #0d1117;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.hr-chart-root--dark .hr-chart-y-label,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-chart-y-label {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.hr-chart-root--dark .hr-chart-tick,\n.hr-chart-root--dark .hr-chart-axis-title,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-chart-tick,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-chart-axis-title {\n  fill: rgba(255, 255, 255, 0.85);\n}\n\nhtml[data-theme=\"light\"] .hr-chart-root .hr-chart-tick,\nhtml[data-theme=\"light\"] .hr-chart-root .hr-chart-axis-title,\nbody[data-theme=\"light\"] .hr-chart-root .hr-chart-tick,\nbody[data-theme=\"light\"] .hr-chart-root .hr-chart-axis-title,\nbody.light-mode .hr-chart-root .hr-chart-tick,\nbody.light-mode .hr-chart-root .hr-chart-axis-title {\n  fill: #0f172a !important;\n}\n\n.hr-chart-root--dark .hr-chart-slider__input,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-chart-slider__input {\n  background: linear-gradient(90deg, #1f2937, #374151);\n}\n\n.hr-chart-root--dark .hr-chart-slider__input::-webkit-slider-thumb,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-chart-slider__input::-webkit-slider-thumb {\n  border-color: #0d1117;\n}\n\n.hr-chart-root--dark .hr-chart-slider__input::-moz-range-thumb,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-chart-slider__input::-moz-range-thumb {\n  border-color: #0d1117;\n}\n\n.hr-chart-root--dark .hr-chart-slider__readout,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-chart-slider__readout {\n  color: rgba(248, 250, 252, 0.7);\n}\n\n.hr-chart-root--dark .hr-chart-slider__readout strong,\nhtml[data-theme=\"dark\"] .hr-chart-root .hr-chart-slider__readout strong {\n  color: #f8fafc;\n}\n\n.hr-chart-root--compact {\n  max-width: none;\n}\n\n.hr-chart-root--compact .hr-summary-section {\n  padding: 10px 10px 12px;\n  margin-bottom: 8px;\n  border-radius: 14px;\n}\n\n.hr-chart-root--compact .hr-summary-heading {\n  font-size: 0.92rem;\n  margin-bottom: 10px;\n}\n\n.hr-chart-root--compact .hr-summary-cards {\n  gap: 8px;\n}\n\n.hr-chart-root--compact .hr-chart-canvas {\n  min-height: 0;\n  margin-top: 4px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
